import { createBlock, mergeBlock, t } from "@easy-email-pro-core/utils";

import { ElementCategory, StandardType } from "@easy-email-pro-core/constants";
import {
  ElementDefinition,
  StandardSocialItemElement,
  StandardSpacerElement,
} from "@easy-email-pro-core/typings";
import React from "react";
import { Spacer } from "@easy-email-pro-core/components/Elements";
import { Spacer as SourceElement } from "../../basic/Spacer";

const defaultData: ElementDefinition<StandardSocialItemElement>["defaultData"] =
  mergeBlock(SourceElement.defaultData, {
    attributes: {},
    data: {},
  });

export const StandardSpacer = createBlock<StandardSpacerElement>({
  get name() {
    return t("Spacer");
  },
  void: true,
  defaultData,
  type: StandardType.STANDARD_SPACER,
  create: (payload) => {
    const defaultData: StandardSpacerElement = {
      type: StandardType.STANDARD_SPACER,
      data: {},
      attributes: {},
      children: [],
    };
    return mergeBlock(defaultData, payload);
  },
  category: ElementCategory.SPACER,
  render(params) {
    const { node } = params;
    return (
      <Spacer
        idx={params.idx}
        {...node.attributes}
        data={node.data}
        children={params.children || node.children}
      />
    );
  },
});
